import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumb } from "reactstrap";

const PageHeader = (props) => {

    let HeaderTitle = props.headertitle;
    let publicUrl = process.env.PUBLIC_URL + "/";
    let Subheader = props.subheader ? props.subheader : HeaderTitle;
    let CustomClass = props.customclass ? props.customclass : "";
    let Img = props.Img ? props.Img : "14.jpg";
    const breadcrumbs = props.breadcrumbs ? props.breadcrumbs : [HeaderTitle];

    return (
        <div
            className={`ltn__breadcrumb-area text-left bg-overlay-white-30 bg-image ${CustomClass}`}
            data-bs-bg={publicUrl + "assets/img/bg/20.jpg"}
        >
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="ltn__breadcrumb-inner text-center">
                            <h1 className="page-title">
                                {HeaderTitle}
                            </h1>
                            <div className="ltn__breadcrumb-list">
                                <ul>
                                    <li>
                                        <Link to="/">
                                            <span className="ltn__secondary-color">
                                                <i className="fas fa-home" />
                                            </span>{" "}
                                            Accueil
                                        </Link>
                                    </li>
                                    {
                                        breadcrumbs.map((bc, index) => {
                                            return (
                                                <li key={index}>{bc}</li>
                                            );
                                        })
                                    }
                                    {/* <li>{Subheader}</li> */}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PageHeader;
